
const state = {
    now: new Date(),
    snackbar: {},
    showSnackbar: false,
    roles: [],
    panelWidth: 400,
}

// getters
const getters = {}

const actions = {
    start({commit}) {
        setInterval(() => {
            commit('updateTime')
        }, 1000 * 20)
    },
    success({commit}, text) {
        commit('setSnackbar', {text: text, color: 'success', timeout: 3000})
    },
    error({commit}, text) {
        commit('setSnackbar', {text: text, color: 'error', timeout: 3000})
    },
    setRoles({commit}, roles) {
        if (typeof roles === 'string') {
            commit('setRoles', [roles])
        } else {
            commit('setRoles', roles)
        }

    },
    updatePanelWidth({commit}, width) {
        commit('setPanelWidth', width)
    },
}

const mutations = {
    updateTime(state) {
        state.now = new Date()
    },
    setShowSnackbar(state, value) {
        state.showSnackbar = value
    },
    setSnackbar(state, value) {
        state.snackbar = value
        state.showSnackbar = true
    },
    setRoles(state, value) {
        state.roles = value
    },
    setPanelWidth(state, value) {
        state.panelWidth = value
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}
